<template>
    <footer
        v-show="isFooterBarVisible"
        class="py-2 pl-40 dark:bg-gray-900"
    >
        <level>
            <div class="md:py-2">
                <b>&copy; {{ year }},
                    <a
                        href="https://nextbase.co.jp/"
                        target="_blank"
                    >
                        NextBase Corp.
                    </a>
                </b>
            </div>
        </level>
    </footer>
</template>

<script>
import Level from '@/components/Utilities/Level'
import { computed } from 'vue'
import { useStore } from 'vuex'

export default {
    name: 'FooterBar',
    components: {
        Level
        // JbLogo
    },
    setup () {
        const store = useStore()
        const year = computed(() => new Date().getFullYear())
        const isFooterBarVisible = computed(() => !store.state.isFullScreen)

        return {
            year,
            isFooterBarVisible
        }
    }
}
</script>
